import React from "react";
import { useRouter } from "next/router";
import useAuth from "../../contexts/AuthContext";

import LogoSvg from "../svgs/LogoSvg";
import CircularButton from "../ui-kit/buttons/CircularButton";
import Divider from "../ui-kit/divider/Divider";
import CrossSvg from "../ui-kit/icons/CrossSvg";
import UserLoggedIn from "../ui-kit/user/UserLoggedIn";
import NavBar from "./NavBar";
import RegisterCallToAction from "../ui-kit/call-to-actions/RegisterCallToAction";
import { RightChevronSvg } from "../ui-kit/icons/ChevronSvg";
import Link from "next/link";
import { MY_ACCOUNT_PAGES } from "../../constants";
import Button from "../ui-kit/buttons/Button";

const MobileSidenav = ({ toggleMenu }) => {
  const router = useRouter();
  const { loggedInUser, logout } = useAuth();

  const onLogout = (e) => {
    e.preventDefault();
    logout();
    router.replace("/");
  };

  return (
    <div className="fixed inset-0 z-50 h-full overflow-hidden bg-white lg:hidden dark:bg-theme-dark-bg">
      <div className="">
        <div className="flex items-center justify-between py-4 mx-4">
          <div className="flex items-center h-8">
            <LogoSvg className="w-auto h-6" />
          </div>

          <CircularButton
            type="primary"
            Icon={
              <CrossSvg className="w-4 h-4 text-black stroke-current stroke-2" />
            }
            className="w-6 h-6 bg-white "
            onClick={toggleMenu}
          />
        </div>
      </div>

      <div className="flex flex-col h-screen space-y-2 bg-white dark:bg-theme-dark-bg lg:hidden">
        <Divider />
        {loggedInUser ? (
          <>
            <Link href="/perfil">
              <div className="flex items-center justify-between px-4 my-4">
                <UserLoggedIn user={loggedInUser} />
                <RightChevronSvg className="w-8 h-8 text-gray-900 stroke-current stroke-2 dark:text-white" />
              </div>
            </Link>
            <Divider />
          </>
        ) : (
          <div className="px-4">
            <RegisterCallToAction />
          </div>
        )}

        <NavBar />

        {loggedInUser && (
          <div>
            <Divider />
            <div className="my-4 mx-6">
              <Link href={`/perfil?page=${MY_ACCOUNT_PAGES.PROJECTS}`}>
                <a>
                  <Button size="sm" block type="secondary" >Publicar Proyecto</Button>
                </a>
              </Link>
            </div>
            <Divider />
            <div className="flex items-center justify-center px-4 my-4">
              <button
                className="w-full py-3 text-gray-700 dark:text-gray-300 underline"
                onClick={onLogout}
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileSidenav;
